import { FileType } from '@empathy/global/data';

export const LOOP_STIMULUS_TYPES = [FileType.ImageSvg, FileType.ImagePng, FileType.ImageGif, FileType.ImageJpeg, FileType.VideoMp4, FileType.AudioMp3];
